import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

export default function NotificationLeadTime({ initialValue, setValue, label }) {
  const { t } = useTranslation();
  const [amount, setAmount] = useState(0);
  const [unit, setUnit] = useState("hours");
  useEffect(() => {
    const [hours, minutes] = String(initialValue || "00:00").split(":").map(Number);
    const rounded = Math.max(0, (hours || 0) + (minutes > 0 ? 1 : 0));
    setAmount(rounded % 24 === 0 ? rounded / 24 : rounded);
    setUnit(rounded % 24 === 0 ? "days" : "hours");
  }, [initialValue]);
  const update = (nextAmount, nextUnit) => {
    setAmount(nextAmount);
    setUnit(nextUnit);
    if (nextAmount === "") return;
    const hours = Number(nextAmount) * (nextUnit === "days" ? 24 : 1);
    setValue(`${String(hours).padStart(2, "0")}:00`);
  };
  return <TimeField role="group" aria-label={label}>
    <Amount type="number" inputMode="numeric" min="0" step="1" required aria-label={label} value={amount} onChange={event => {
      const next = event.target.value;
      if (next === "" || (Number.isInteger(Number(next)) && Number(next) >= 0)) update(next, unit);
    }} />
    <Units>
      {["hours", "days"].map(value => <UnitButton key={value} type="button" aria-pressed={unit === value} onClick={() => update(amount, value)}>{t(`ui.i18nFinalCleanup.${value}`)}</UnitButton>)}
    </Units>
  </TimeField>;
}
const TimeField = styled.div`
  display: flex; align-items: center; gap: 10px; max-width: 100%;
`;
const Amount = styled.input`
  width: 76px; min-width: 0; height: 40px; border: 1px solid #dce6e1;
  border-radius: 8px; padding: 8px 10px; background: white; color: #344b43;
  font: inherit; font-size: 14px; font-variant-numeric: tabular-nums;
  &&:focus, &&:focus-visible { outline: none; border-color: #7f9e94; box-shadow: 0 0 0 2px rgba(127,158,148,.14); }
  @media (max-width: 600px) { font-size: 16px; }
`;
const Units = styled.div`
  display: flex; gap: 2px; padding: 3px; border-radius: 8px; background: #f2f6f4; min-width: 0;
`;
const UnitButton = styled.button`
  border: 0; border-radius: 6px; min-height: 34px; padding: 6px 10px;
  background: transparent; color: #76877e; font: inherit; font-size: 12px; cursor: pointer;
  &[aria-pressed="true"] { background: white; color: #3d6554; box-shadow: 0 1px 3px rgba(43,66,57,.06); }
  &:hover { color: #344b43; }
`;
